import React from 'react'
import styled from 'react-emotion'
import { css } from 'emotion'

import { Container, Row, Col } from '../../components/Bootstrap'

import { colours, mq, spacers } from '../../theme'
import { bold } from '../../styles'
import { colourContrast } from '../../utils'

const LargeText = styled('h2')`
	background-color: ${props => (props.background)};
	color: ${props => (colourContrast(props.background))};
	${mq.medium(css`
		font-size: 6.6666rem;
	`)}
	font-size: 4.5rem;
	margin: ${spacers['4']} 0;
	margin-right: ${spacers['3']};
	padding: ${spacers['4']};
	text-transform: uppercase;
`

const BoldText = styled('p')`
	${bold};
	margin-bottom: 0;
`

const VisionMission = () => (
	<Container fluid>
		<Row className="justify-content-start align-items-center">
			<Col md="6">
				<LargeText background={colours.primary}>Vision</LargeText>
			</Col>
			<Col md="3">
				<BoldText>A society where people with disabilities achieve social and economic equity</BoldText>
			</Col>
		</Row>
		<Row className="justify-content-start align-items-center">
			<Col md="6">
				<LargeText background={colours.secondary}>Mission</LargeText>
			</Col>
			<Col md="3">
				<BoldText>To promote this vision through an inclusive approach based on the independent living philosophy</BoldText>
			</Col>
		</Row>
	</Container>
)

export default VisionMission
